import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/style.css";
import FirebaseContext from "../firebase/firebaseContext";

const Navbar = () => {
  const firebaseContext = useContext(FirebaseContext);
  const [user, setUser] = useState(false);
  const { auth } = firebaseContext;

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        setUser(true);
      }
    });
  }, []);

  return (
    <header className='header'>
      <h1 className='logo'>
        <Link to='/'>Biologija - naravoslovje</Link>
      </h1>
      <ul className='main-nav'>
        {user && (
          <li>
            <Link to='/create'>Dodaj uro</Link>
          </li>
        )}
        {user && (
          <li>
            <Link to='/createExercise'>Dodaj vajo</Link>
          </li>
        )}
        <li>
          <Link to='/naloge'>Učne ure</Link>
        </li>
        <li>
          <Link to='/vaje'>Vaje</Link>
        </li>
        <li>
          <Link to='/dostop'>Dostop</Link>
        </li>
        <li>
          <Link to='/login'>
            <button>Vpiši se</button>
          </Link>
        </li>
      </ul>
    </header>
  );
};

export default Navbar;
